import React from 'react'
import { Link } from 'gatsby'
import './navbar.css'
import InfoIcon from '@material-ui/icons/InfoTwoTone'
import BookIcon from '@material-ui/icons/BookTwoTone'
import ContactMailIcon from '@material-ui/icons/ContactMailTwoTone'

const Navbar = () => {
  return (
    <nav className="my-navbar">
      <div className="navbar-container">
        <Link className="navbar-item" activeClassName="active-link" to="/">
          <InfoIcon fontSize="small" />
          <span>About</span>
        </Link>
        <Link className="navbar-item" activeClassName="active-link" to="/blog">
          <BookIcon fontSize="small" />
          <span>Blog</span>
        </Link>
        <Link className="navbar-item" activeClassName="active-link" to="/contact">
          <ContactMailIcon fontSize="small" />
          <span>Contact</span>
        </Link>
      </div>
    </nav>
  )
}

export default Navbar
